import { useEffect, useState } from "react";
import Card from "components/card";
import { XMarkIcon, ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { BiExtension } from "react-icons/bi";

export default function ExtensionBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            const dismissed = localStorage.getItem("df_ext_banner_dismissed");
            if (!dismissed) setVisible(true);
        } catch (e) {
            setVisible(true);
        }
    }, []);

    if (!visible) return null;

    const installUrl =
        "https://chromewebstore.google.com/detail/duckflow-plugin/bhkkohcgcgamnmboafepkfdehmiphmcc?hl=fr";

    return (
        <Card extra={"p-3 lg:p-4 border"}>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                <div className="flex items-start sm:items-center gap-3">
                    <div className="flex items-center justify-center w-10 h-10 rounded-md bg-primary/10 text-primary">
                        <BiExtension className="w-6 h-6" />
                    </div>
                    <div>
                        <div className="text-sm font-semibold text-navy-700 dark:text-white">Install DuckFlow Chrome extension</div>
                        <div className="text-xs text-gray-500 mt-1">Capture prospects with one click and sync them to your workspace.</div>
                    </div>
                </div>

                <div className="flex items-center gap-2">
                    <a
                        href={installUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="inline-flex items-center gap-2 bg-black px-3.5 py-1.5 rounded-full text-xs text-white shadow-sm hover:opacity-95"
                        aria-label="Install DuckFlow extension"
                    >
                        Install
                        <ArrowTopRightOnSquareIcon className="w-3 h-3 text-white" />
                    </a>

                    <button
                        onClick={() => {
                            localStorage.setItem("df_ext_banner_dismissed", "1");
                            setVisible(false);
                        }}
                        className="inline-flex items-center justify-center w-8 h-8 rounded-md text-gray-400 hover:text-gray-600"
                        aria-label="Dismiss"
                        title="Dismiss"
                    >
                        <XMarkIcon className="w-5 h-5" />
                    </button>
                </div>
            </div>
        </Card>
    );
}
